import React, { useRef, useEffect } from "react";
import PlayCircleFilledWhiteOutlinedIcon from "@material-ui/icons/PlayCircleFilledWhiteOutlined";
import { toKebabCase } from "../../helpers/cssHelper";
import PollModule from "../../digitalArena/modules/PollModule/PollModule";
import { combineProps, deepClone } from "../../helpers/objectHelper";
import ExhibitorModule from "../../digitalArena/modules/ExhibitorModule/ExhibitorModule";
import { ImageModule } from "../../digitalArena/modules/ImageModule";
import BreakoutModule from "../../digitalArena/modules/BreakoutModule/BreakoutModule";
import ConnectionsModule from "../../digitalArena/modules/ConnectionsModule/ConnectionsModule";
import ClientListModule from "../../digitalArena/modules/ClientListModule/ClientListModule";
import ZoomModule from "../../digitalArena/modules/ZoomModule/ZoomModule";
import AgendaModule from "../../digitalArena/modules/AgendaModule/AgendaModule";
import PresenterModule from "../../digitalArena/modules/PresenterModule/PresenterModule";
import ButtonModule from "../../digitalArena/modules/ButtonModule";
import { BlockModule } from "../../digitalArena/modules/BlockModule";
import TextModule from "../../digitalArena/modules/TextModule";
import GroupGeneratorModule from "../../digitalArena/modules/GroupGeneratorModule";
import ChatModule from "../../digitalArena/modules/ChatModule/ChatModule";
import { IframeModule } from "../../digitalArena/modules/IframeModule";
import { RatioWrapper } from "../../digitalArena/components/MeetingLayoutModule";
import CountdownModule from "../../digitalArena/modules/CountdownModule/CountdownModule";
import { ImageMapModule } from "../../digitalArena/modules/ImageMapModule";
import UserCardModule from "../../digitalArena/modules/UserCardModule/UserCardModule";
import { HtmlModule } from "../../digitalArena/modules/HtmlModule";
import SpeakerControl from "../../digitalArena/modules/SpeakerControl/SpeakerControl";
import SpeakerCard from "../../digitalArena/modules/SpeakerCard";
import { SpeakerList } from "../../digitalArena/modules/SpeakerList.js/SpeakerList";
import { EventName } from "../../digitalArena/modules/EventName";
import { ContentView } from "../../digitalArena/modules/ContentView/ContentView";
import { VideoWallModule } from "../../digitalArena/modules/VideoWallModule/VideoWallModule";
import PlauditButtons from "../../digitalArena/modules/Plaudit/PlauditButtons";
import PlauditTrack from "../../digitalArena/modules/Plaudit/PlauditTrack";

export function getDefaultPosAndSize(type, pos) {
  switch (type) {
    case "Html":
      return {
        height: "25%",
        width: "25%",
        posX: pos ? pos.x.toString().substr(0, 8) : "25%",
        posY: pos ? pos.y.toString().substr(0, 8) : "25%",
        zIndex: 1,
      };
    case "TextModule":
      return {
        height: "25%",
        width: "25%",
        posX: pos ? pos.x.toString().substr(0, 8) : "25%",
        posY: pos ? pos.y.toString().substr(0, 8) : "25%",
        zIndex: 2,
      };
    case "ButtonModule":
      return {
        height: "3.5%",
        width: "6%",
        posX: pos ? pos.x.toString().substr(0, 8) : "25%",
        posY: pos ? pos.y.toString().substr(0, 8) : "25%",
        zIndex: 2,
      };
    case "Chat":
      return {
        height: "50%",
        width: "25%",
        posX: pos ? pos.x.toString().substr(0, 8) : "25%",
        posY: pos ? pos.y.toString().substr(0, 8) : "25%",
        zIndex: 2,
      };
    case "Connections":
    case "UserCard":
      return {
        height: "10%",
        width: "20%",
        posX: pos ? pos.x.toString().substr(0, 8) : "25%",
        posY: pos ? pos.y.toString().substr(0, 8) : "25%",
        zIndex: 2,
      };

    default:
      return {
        height: "25%",
        width: "25%",
        posX: pos ? pos.x.toString().substr(0, 8) : "25",
        posY: pos ? pos.y.toString().substr(0, 8) : "25",
        zIndex: 1,
      };
  }
}
const aspecRatio = (w, h, ratio, bound) => {
  const defStyle = { height: "100%", width: "100%" };
  switch (ratio) {
    case "16:9":
      return {
        ...defStyle,
        /* paddingTop: "56.2%",  */ maxHeight: bound.clientWidth * (parseInt(w) / 100) * 0.562,
      };
    case "16:10":
      return {
        ...defStyle,
        maxHeight: bound.clientWidth * (parseInt(w) / 100) * 0.625,
      };
    case "4:3":
      return {
        ...defStyle,
        maxHeight: bound.clientWidth * (parseInt(w) / 100) * 0.75,
      };
    default:
      return defStyle;
  }
};

const props = (extra, settings) => {
  return { ...extra, ...settings };
};
/* const RatioWrapper = ({
  children,
  height,
  width,
  aspectRatio,
  lockAspectRatio,
  bound,
}) => {
  if (!lockAspectRatio) return children;
  return (
    <div
      style={
        lockAspectRatio ? aspecRatio(width, height, aspectRatio, bound) : {}
      }
    >
      {children}
    </div>
  );
}; */
export function renderModulePlaceholder(type, template, extra, settings, updateModule) {
  switch (type) {
    case "Chat":
      return <ChatModule {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />;
    case "Presenter":
      return <PresenterModule {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />;
    case "GroupGenerator":
      return <GroupGeneratorModule {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />;
    case "Image":
      return <ImageModule {...combineProps([extra, { settings }])} />;
    case "Html":
      return <HtmlModule {...combineProps([extra, { settings }, { lang: "swe", preview: true, updateModule }])} />;

    case "Agenda":
      return <AgendaModule {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />;
    case "ZoomFrame":
      return (
        <RatioWrapper {...combineProps([extra, { settings, preview: true }])}>
          <ZoomModule {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />
        </RatioWrapper>
      );
    case "ContentView":
      return <ContentView {...combineProps([extra, { settings, layout: extra.layout }, { lang: "swe", preview: true }])} />;
    case "JitsiFrame":
      return <RatioWrapper {...combineProps([extra, { settings, preview: true }])}>{defaultVideoFrame()}</RatioWrapper>;
    case "SpeakerCard":
      return <SpeakerCard {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />;
    case "Video":
      return (
        <RatioWrapper {...combineProps([extra, { settings, preview: true }])}>
          {settings.url ? (
            <div
              style={{
                width: "100%",
                height: "100%",
                position: "relative",
                backgroundColor: "#000",
              }}
            >
              <video id={"jirango-vod"} class="video-js" controls preload="auto" style={{ width: "100%", height: "100%" }} poster="MY_VIDEO_POSTER.jpg" controlsList="nodownload" data-setup="{}">
                <source src={settings.url} type="video/mp4" />
                <source src={settings.url} type="video/webm" />
                <p class="vjs-no-js">
                  To view this video please enable JavaScript, and consider upgrading to a web browser that
                  <a href="https://videojs.com/html5-video-support/" target="_blank">
                    supports HTML5 video
                  </a>
                </p>
              </video>
            </div>
          ) : (
            defaultVideoFrame()
          )}
        </RatioWrapper>
      );
    case "CountdownModule":
      return <CountdownModule {...combineProps([extra, { settings }])} />;
    case "Iframe":
      return (
        <RatioWrapper {...combineProps([extra, { settings, preview: true }])}>
          <IframeModule {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />
        </RatioWrapper>
      );
    case "Connections":
      return <ConnectionsModule {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />;
    case "SpeakerList":
      return <SpeakerList {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />;
    case "Exhibitors":
      return <ExhibitorModule {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />;
    case "UserCard":
      return <UserCardModule {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />;
    case "ClientList":
      return <ClientListModule {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />;
    case "Breakouts":
      return <BreakoutModule {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />;
    case "BlockModule":
      return <BlockModule {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />;
    case "TextModule":
      return <TextModule {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />;
    case "ButtonModule":
      return <ButtonModule {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />;
    case "PollModule":
      return <PollModule {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />;
    case "VonageVideoClientModule":
      return defaultVideoFrame();
    case "ImageMap":
      return <ImageMapModule {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />;
    case "SpeakerControl":
      return <SpeakerControl {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />;
    case "EventName":
      return <EventName {...combineProps([extra, { settings }, { lang: "swe", preview: true }])} />;
    case "VideoWallModule":
      return <VideoWallModule {...combineProps([extra, { template, settings }, { lang: "swe", preview: true }])} />;

    case "PlauditButtons":
      return <PlauditButtons {...combineProps([extra, { template, settings }, { lang: "swe", preview: true }])} />
    case "PlauditTrack":
      return <PlauditTrack {...combineProps([extra, { template, settings }, { lang: "swe", preview: true }])} />
    default:
      return <div />;
  }
}

const defaultVideoFrame = () => (
  <div
    style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#222",
      position: "relative",
    }}
  >
    <PlayCircleFilledWhiteOutlinedIcon className="centered-text c-w" style={{ fontSize: "10vh" }} />
  </div>
);

export function checkForUpdates(target, source) {
  if (Array.isArray(source)) {
    return;
  }
  const targetObj = Object.assign({}, target);
  for (const key in source) {
    if (!targetObj.hasOwnProperty(key)) {
      targetObj[key] = source[key];
    }
  }
  return targetObj;
}

export const GridLines = (props) => {
  const { grid } = props;
  /*   const bounds = document.getElementById('#GridView') */
  let width = grid.clientWidth;
  let height = grid.clientHeight;
  let incrementX = width / 100;
  let incrementY = height / 100;

  const canvasRef = useRef(null);
  const draw = (ctx) => {
    ctx.canvas.width = width;
    ctx.canvas.height = height;

    for (let x = 0; x <= 100; x += 1) {
      ctx.moveTo(x * incrementX, 0);
      ctx.lineTo(x * incrementX, height);
    }
    ctx.strokeStyle = "#1f87ad25";
    ctx.lineWidth = 1;
    ctx.stroke();
    for (let y = 0; y <= 100; y += 1) {
      ctx.moveTo(0, y * incrementY);
      ctx.lineTo(width, y * incrementY);
    }
    ctx.strokeStyle = "#1f87ad25";
    ctx.lineWidth = 2;
    ctx.stroke();
  };
  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    //Our draw come here
    draw(context);
  }, [draw]);

  return <canvas width={width} height={height} ref={canvasRef} {...props} />;
};
